import { updateFeed } from "@/mocks/scandal";

export default function Updates() {
  return (
    <section id="update" className="border-b border-background-200/70 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="inline-block h-4 w-1.5 rounded-sm bg-primary-500" />
              <span className="text-xs font-bold uppercase tracking-widest text-primary-600">Latest Archive</span>
            </div>
            <h2 className="font-heading mt-2 text-2xl font-black text-foreground-950 md:text-3xl">
              最新更新流 · 抖音黑料发展经过进行时
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              节点、回应、补图、归档——凡是对理解前因后果有用的变化，都第一时间摆在这里。
            </p>
          </div>
          <a
            href="#timeline"
            className="inline-flex w-fit items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-semibold text-foreground-700 whitespace-nowrap hover:border-primary-300 hover:text-primary-700"
          >
            回到主线
            <i className="ri-corner-down-left-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {updateFeed.map((u, i) => (
            <article
              key={i}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 hover:bg-primary-50/40"
            >
              <div className="flex items-center gap-2">
                <span className={`rounded-full px-2 py-0.5 text-[11px] font-bold ${u.tagColor}`}>{u.tag}</span>
                <span className="text-[11px] text-foreground-400">{u.time}</span>
                {u.hot && (
                  <span className="ml-auto flex items-center gap-1 text-[11px] font-bold text-primary-600 whitespace-nowrap">
                    <i className="ri-fire-fill" /> 热门
                  </span>
                )}
              </div>
              <h3 className="mt-3 text-[15px] font-bold leading-snug text-foreground-900 group-hover:text-primary-700">
                {u.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{u.excerpt}</p>
              <a
                href="#timeline"
                className="mt-3 flex items-center gap-1 text-xs font-semibold text-primary-600 hover:text-primary-700"
              >
                查看该节点
                <i className="ri-arrow-right-line" />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}